/* eslint-disable */
import fr from 'facet-rest';

const makeOverrideFromFields = (fields, titleGenerator = null) => {
  const override = fr.metaOverride();
  override.nameOverride(name => !fields.includes(name), { hidden: true });

  fields.forEach((field, index) => {
    override.nameOverride(field, { ordinal: index });
  });

  override.nameOverride('updatedAt', { _titleGenerator: titleGenerator });

  return override;
};

export const titleGeneratorByExpenseType = {
  homeRelated: () => () => 'Home Related Expenses',
  savings: () => () => 'Savings',
  debt: () => () => 'Debt Payments',
  lifestyle: () => () => 'Lifestyle Expenses',
  transportation: () => () => 'Transportation Expenses',
  tax: () => () => 'Transportation Expenses',
};

const savingsHistoryFields = [
  'cashSavings',
  'retirementPlans',
  'otherInvestments',
  'education',
  'otherSavings',
];
const savingsHistoryOverride = makeOverrideFromFields(
  savingsHistoryFields,
  titleGeneratorByExpenseType.savings,
);

const debtHistoryFields = ['loanStudent', 'paymentCreditCards', 'loanOther'];
const debtHistoryOverride = makeOverrideFromFields(
  debtHistoryFields,
  titleGeneratorByExpenseType.debt,
);

const lifestyleHistoryFields = [
  'insuranceHealth',
  'insuranceDisability',
  'insuranceLife',
  'insuranceLongTermCare',
  'insuranceOther',
  'groceries',
  'personalSuppliesOrClothing',
  'diningOrEatingOut',
  'moviesVideosHobbies',
  'sports',
  'vacationOrTravel',
  'charitableGivingTithe',
  'childcareOrEducation',
  'other',
];

const lifestyleHistoryOverride = makeOverrideFromFields(
  lifestyleHistoryFields,
  titleGeneratorByExpenseType.lifestyle,
);

const homeRelatedHistoryFields = [
  'mortgageOrRent',
  'insuranceHomeownersOrRenters',
  'insuranceUmbrella',
  'billUtilities',
  'billTelecommunications',
  'maintenanceRepairsImprovements',
  'generalExpenses',
];

const homeRelatedHistoryOverride = makeOverrideFromFields(
  homeRelatedHistoryFields,
  titleGeneratorByExpenseType.homeRelated,
);

const transportationHistoryFields = [
  'carLoan',
  'carLease',
  'carInsurance',
  'gas',
  'publicTransportation',
  'generalTransportation',
];

const taxHistoryFields = [
  'taxFederal',
  'taxFederalFrequency',
  'taxState',
  'taxStateFrequency',
  'taxSocialSecurity',
  'taxSocialSecurityFrequency',
  'taxMedicare',
  'taxMedicareFrequency',
];

const transportationHistoryOverride = makeOverrideFromFields(
  transportationHistoryFields,
  titleGeneratorByExpenseType.transportation,
);

const taxHistoryOverride = makeOverrideFromFields(taxHistoryFields, () => () =>
  'Taxes',
);


export const expenseOverrideByType = {
  homeRelated: homeRelatedHistoryOverride,
  savings: savingsHistoryOverride,
  debt: debtHistoryOverride,
  lifestyle: lifestyleHistoryOverride,
  transportation: transportationHistoryOverride,
  tax: taxHistoryOverride,
};
